<template>
  <div class="dropdown-options-wuk sword-boxed-input-wuk"
      ref="dropdownOptionsWrapper"
       v-if="show"
       @focus.prevent
       tabindex="-1"
       :class="{ '--searchable' : searchable, '--extended': extendDropdown }">
    <ul class="dropdown-list">
      <template v-for="(option, key) in optionsObject.options">
        <span v-if="!!option.optGroupLabel" :key="key"
              class="dropdown-item-group-label -t_medium -py_2 -pt_2 -pb_1 compact-text">
          {{ $t(option.optGroupLabel) }}
        </span>
        <li v-else-if="option.optDialCode" :key="key">
          <dial-code-item
            class="dropdown-item"
            :country-code="option.optValue"
            :label="option.optLabel"
            :selected="!!option.optValue && value === option.optValue"
            actionable
            @click.native="handleSelection(option, $event)"
          ></dial-code-item>
        </li>
        <li v-else
            :key="key"
            class="dropdown-item compact-text"
            :class="[itemClass(option), itemAlignClass]"
            @click="handleSelection(option, $event)">
          <span class="compact-text"> {{ option.optLabel ? $t(option.optLabel) : option }} </span>
          <span class="item-counter" v-if="shouldShowCounterIndicator(option)"> ({{ option.optCounter }})</span>
        </li>
      </template>

      <li
        v-if="parentSearch && !optionsObject.options.length"
        class="dropdown-item no-result">
        {{ noResultsLabel }} <b>{{ parentSearch }}</b>
      </li>
    </ul>
  </div>
</template>

<script>

import dropdownUtils from '@ui-kit/mixins/inputs/dropdowns';

import inputHandler from '@ui-kit/mixins/inputHandler';
import inputValidationTriggers from '@ui-kit/mixins/inputValidationTriggers';
import DialCodeItem from '@ui-kit/components/micro/dialCodeItem.vue';


export default {
  name: 'swordDropdownOptionsWuk',
  mixins: [dropdownUtils, inputHandler, inputValidationTriggers],
  components: {
    DialCodeItem,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  computed: {
    extendDropdown() {
      return this.optionsObject.options.length > 10;
    },
    itemAlignClass() {
      return `--align-${this.itemAlign}`;
    },
  },
  methods: {
    itemClass(option) {
      return {
        selected: this.selectedOpt && option.optValue === this.selectedOpt.optValue,
        disabled: option.disabled,
        '--grouped': this.optionsObject.grouped,
      };
    },
    handleSelection(option, ev) {
      this.selectOption(option);
      this.removeAsFocus(ev);
      this.close();
    },
    handleBlur({ ev }) {
      if (!ev.relatedTarget || !this.$refs.dropdownOptionsWrapper.contains(ev.relatedTarget)) {
        this.$emit('blur', ev);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "@ui-kit/styles/inputs/shared/_options-lists.scss";

  $search-input-height: calc(#{$input-default-padding-wuk} * 2 + #{$input-font-size-wuk});

  .dropdown-options-wuk {
    @include option-list-container();

    &.--searchable {
      max-height: calc(#{$search-input-height} + #{$dropdown-list-max-height});

      &.--extended {
        max-height: calc(#{$search-input-height} + #{$dropdown-extended-list-max-height});
      }
    }

    .dropdown-list {
      @include options-list-base();
    }

    .dropdown-item-group-label {
      color: $dropdown-item-label-color;
    }

    .dropdown-item {
      @include options-list-item();
      @include options-list-item-states();
      @include options-list-item-align();

      .item-counter {
        display: flex;

        &:before {
          content: ' ';
          white-space: pre;
        }
      }

      &.--grouped {
        @extend %-pl_2;
      }

      &.no-result {
        color: $context-color-3;
        text-align: center;
        justify-content: center;
        gap: .4rem;
      }
    }
  }
  .search-input {
    position: sticky;
    top: 0;
    border-bottom: 1px solid $input-border-color-wuk;
    border-radius: 0;
    display: flex;
    background: white;
    align-items: center;

    .search-icon {
      order: 1;
      color: $input-default-text-color-wuk;
      flex: none;

      &.filled {
        color: $input-filled-text-color-wuk;
      }
    }

    input {
      order: 2;
      &:hover, &:focus {
        & + .search-icon {
          color: $input-filled-text-color-wuk;
        }
      }
    }
  }

</style>
